import { api } from './client';

export interface ClientContactPhone {
  phone: string;
  label: string | null;
}

export interface ClientContactEmail {
  email: string;
  label: string | null;
}

export interface ClientContactItem {
  id: string;
  linkId: string;
  displayName: string;
  position: string | null;
  phones: ClientContactPhone[];
  emails: ClientContactEmail[];
  linkedBy: { id: string; name: string };
  linkedAt: string;
}

export interface UploadedContactItem {
  id: string;
  displayName: string;
  phones: Array<{ number: string; label: string | null }>;
  emails: Array<{ email: string; label: string | null }>;
  employeeName: string;
}

export interface ContactSuggestion {
  uploadedContactId: string;
  displayName: string;
  matchedPhone: string;
  callCount?: number;
  lastCallDate?: string;
}

export interface ContactSuggestions {
  byClientPhone: ContactSuggestion[];
  byCallLog: ContactSuggestion[];
}

export const contactsApi = {
  getClientContacts: async (clientId: number): Promise<ClientContactItem[]> => {
    const { data } = await api.get(`/contacts/client/${clientId}`);
    return data;
  },

  getSuggestions: async (clientId: number): Promise<ContactSuggestions> => {
    const { data } = await api.get(`/contacts/suggestions/${clientId}`);
    return data;
  },

  bind: async (params: {
    uploadedContactId: string;
    clientId: number;
    displayName?: string;
    position?: string;
  }): Promise<void> => {
    await api.post('/contacts/bind', params);
  },

  unlinkContact: async (linkId: string): Promise<void> => {
    await api.delete(`/contacts/links/${linkId}`);
  },

  searchUploaded: async (search: string): Promise<{ items: UploadedContactItem[]; meta: { total: number } }> => {
    const { data } = await api.get('/contacts/uploaded', {
      params: { search, unbound: true, startRow: 0, endRow: 20 },
    });
    return data;
  },
};
